import { services } from '@octadesk-tech/services'
import { getParameterHeaders } from './headers'

export const getSettings = () =>
  services
    .createClient('widgetBff')
    .then(client => client.get('configs', { headers: getParameterHeaders() }))
    .then(res => res.data)
